export default "__VITE_ASSET__8cf810fe__"